import { Injectable } from '@angular/core';
import { DialogService, PromptDialogData, PromptDialogResult } from '@controladad/ng-base';
import { BannerDialogComponent, BannerDialogData, BannerDialogResult } from './banner-dialog/banner-dialog.component';
import { TagDialogComponent, TagDialogData, TagDialogResult } from './tag-dialog/tag-dialog.component';
import {
  BlogCategoryDialogComponent,
  BlogCategoryDialogData,
  BlogCategoryDialogResult,
} from './blog-category-dialog/blog-category-dialog.component';
import {
  ProductDialogComponent,
  ProductDialogData,
  ProductDialogResult,
} from './product-dialog/product-dialog.component';

import { BlogDialogComponent } from './blog-dialog/blog-dialog.component';
import { EditorDialogComponent, EditorDialogData, EditorDialogResult } from './editor-dialog/editor-dialog.component';
import {
  ImageUploadDialogComponent,
  ImageUploadDialogData,
  ImageUploadDialogResult,
} from './image-upload-dialog/image-upload-dialog.component';
import { CropperDialogComponent, CropperDialogData, CropperDialogResult } from '@/index';
import {
  CategoryDialogComponent,
  CategoryDialogData,
  CategoryDialogResult,
} from './category-dialog/category-dialog.component';
import {
  ProductImageDialogComponent,
  ProductImageDialogData,
  ProductImageDialogResult,
} from './product-image-dialog/product-image-dialog.component';
import {
  ProductListDialogComponent,
  ProductListDialogData,
  ProductListDialogResult,
} from './product-list/product-list-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogExtendedService extends DialogService {
  banner(data?: BannerDialogData) {
    return this.dialog.open<BannerDialogComponent, BannerDialogData, BannerDialogResult>(
      BannerDialogComponent,
      data ?? {},
      {
        minWidth: '50vw',
        maxWidth: '95vw',
        minHeight: '50vh',
        maxHeight: '95vh',
      },
    );
  }

  tag(data?: any) {
    return this.dialog.open<any, any, any>(TagDialogComponent, data ?? {}, {
      minWidth: '50vw',
      maxWidth: '95vw',
      minHeight: '50vh',
      maxHeight: '95vh',
    });
  }

  category(data?: CategoryDialogData) {
    return this.dialog.open<CategoryDialogComponent, CategoryDialogData, CategoryDialogResult>(
      CategoryDialogComponent,
      data ?? {},
      {
        minWidth: '50vw',
        maxWidth: '95vw',
        minHeight: '50vh',
        maxHeight: '95vh',
      },
    );
  }

  blog(data?: any) {
    return this.dialog.open<any, any, any>(BlogDialogComponent, data ?? {}, {
      minWidth: '50vw',
      maxWidth: '95vw',
      minHeight: '50vh',
      maxHeight: '95vh',
    });
  }

  editor(data: EditorDialogData) {
    return this.dialog.open<EditorDialogComponent, EditorDialogData, EditorDialogResult>(EditorDialogComponent, data, {
      disableClose: true,
      minWidth: '100vw',
      minHeight: '100vh',
    });
  }

  imageUpload(data?: ImageUploadDialogData) {
    return this.dialog.open<ImageUploadDialogComponent, ImageUploadDialogData, ImageUploadDialogResult>(
      ImageUploadDialogComponent,
      data,
      {
        minHeight: '17rem',
        maxWidth: '90vw',
        maxHeight: '90vh',
      },
    );
  }

  cropper(data: CropperDialogData) {
    return this.dialog.open<CropperDialogComponent, CropperDialogData, CropperDialogResult>(
      CropperDialogComponent,
      data,
      {
        maxWidth: '95vw',
        maxHeight: '95vh',
      },
    );
  }
  product(data?: ProductDialogData) {
    return this.dialog.open<ProductDialogComponent, ProductDialogData, ProductDialogResult>(
      ProductDialogComponent,
      data ?? {},
      {
        minWidth: '50vw',
        maxWidth: '75vw',
        maxHeight: '95vh',
      },
    );
  }
  productImage(data?: ProductImageDialogData) {
    return this.dialog.open<ProductImageDialogComponent, ProductImageDialogData, ProductImageDialogResult>(
      ProductImageDialogComponent,
      data,
      {
        maxWidth: '95vw',
        maxHeight: '95vh',
      },
    );
  }
  productList(data: ProductListDialogData) {
    return this.dialog.open<ProductListDialogComponent, ProductListDialogData, ProductListDialogResult>(
      ProductListDialogComponent,
      data,
      {
        minWidth: '50vw',
        maxWidth: '95vw',
        minHeight: '50vh',
        maxHeight: '95vh',
      },
    );
  }

  blogCategory(data?: any) {
    return this.dialog.open<any, any, any>(BlogCategoryDialogComponent, data ?? {}, {
      minWidth: '50vw',
      maxWidth: '95vw',
      minHeight: '50vh',
      maxHeight: '95vh',
    });
  }
}
